import { RecipeComment } from '../api/Types';

interface CommentNotificationDependencies {
  notifyCommentCreated: (
    recipeId: string,
    commentPreview?: string,
    commentId?: number
  ) => Promise<void>;
}

export const notifyCommentCreatedSafely = (
  dependencies: CommentNotificationDependencies,
  comment: Pick<RecipeComment, 'recipe_id' | 'comment' | 'id'>
): void => {
  void dependencies.notifyCommentCreated(
    comment.recipe_id,
    comment.comment,
    comment.id
  );
};
